import { $http } from '@/utils/service'

interface AreacodeResponse {
  code: string;//国家代码
  name: string; //国家名称
}

export class CurrentCode {
  public static async getAreacode(): Promise<AreacodeResponse> {
    try {
      const response = await $http.get<AreacodeResponse>({ url: 'content/openApi/login/areacode/get', options:{ loading: false, mock: false, error: true } })

      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
